export default __webpack_public_path__ + "static/flatwalls-3088521ba2eee4c341d3d2d1f108437c.png";